module.exports = {
  hasAsteroid: true, // usado caso tenha extensão @bildvitta/asteroid instalada na aplicação
  forbiddenRouteName: 'Forbidden', // usado para definir o nome da rota da pagina de erro 404 (Forbidden)
  storeAdapter: 'pinia', // usado para definir qual store esta utilizando na aplicação "vuex" ou "pinia"
  development: {
    localhost: {
      useAutomaticLogin: true,
      environment: 'temporary',
      url: 'https://vendas-temporary.nave.dev.br'
    },

    preview: {
      useAutomaticLogin: true,
      environment: 'temporary',
      url: 'https://vendas-temporary.nave.dev.br'
    }
  }
}
